<div class="premiumAdTokenPayment">
  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <div class="row">
      <div class="col-12 mb-2">
        <div class="row mb-2" style="padding-left: 15px; width: 475px">
          <div class="col-md-5 d-flex align-items-center" style="padding-right: 0">
            <b class="font-ac securityPaymentInformation" style="color: red;">100% Secure Payment!</b>
          </div>
          <div class="col-md-6 d-flex" style="padding-left: 0">
            <div class="d-flex align-items-center"> <b style="font-size:12px">Secured By:</b></div>
            <div class="pl-3">
              <img src="/images/authorizenet.png">
            </div>
          </div>
        </div>
        <div class="row" style="padding-left: 15px">
          <div class="col-12 mb-2" style="font-size: 14px">
            <b>Charge will appear on your credit card statement as "Armax Technology"</b>
          </div>
        </div>
        <div class="col-md-12">
          <mat-form-field class="w-100">
            <input type="text" formControlName="firstName"
                   matInput
                   placeholder="First name *" />
            <mat-error *ngIf="form.controls['firstName'].hasError('required')">
              Required field
            </mat-error>
          </mat-form-field>
        </div>
        <div class="col-md-12">
          <mat-form-field class="w-100">
            <input type="text" formControlName="lastName"
                   matInput
                   placeholder="Last name *" />
            <mat-error *ngIf="form.controls['lastName'].hasError('required')">
              Required field
            </mat-error>
          </mat-form-field>
        </div>
        <div class="col-md-12">
          <mat-form-field class="w-100">
            <input type="text" formControlName="zip"
                   matInput
                   placeholder="Zip Code *" />
            <mat-error *ngIf="form.controls['zip'].hasError('required')">
              Required field
            </mat-error>
          </mat-form-field>
        </div>
        <div class="col-md-12">
          <mat-form-field class="w-100">
            <input formControlName="creditCard"
                   matInput
                   placeholder="Credit Card *"
                   id="cc-number"
                   type="tel"
                   autocomplete="cc-number"
                   ccNumber />
            <mat-error *ngIf="form.controls['creditCard'].hasError('ccNumber')">
              Please enter a valid credit card number.
            </mat-error>
          </mat-form-field>
        </div>
        <div class="row pr-3 m-0">
          <div class="col-md-12">Expiration Date</div>
          <div class="col-md-5">
            <mat-form-field class="w-100">
              <input formControlName="expirationDateMonth"
                     matInput
                     placeholder="MM*"
                     id="cc-exp-date-m"
                     type="tel" />
              <mat-error *ngIf="
                    form.controls['expirationDateMonth'].hasError('required')
                  ">
                Please enter a valid expiration date - MM
              </mat-error>
            </mat-form-field>
          </div>
          <div class="p-0 col-md-1 pt-3">
            /
          </div>
          <div class="col-md-5 p-0">
            <mat-form-field class="w-100">
              <input formControlName="expirationDateYear"
                     matInput
                     placeholder="YYYY*"
                     id="cc-exp-date-y"
                     type="tel" />
              <mat-error *ngIf="
                    form.controls['expirationDateYear'].hasError('required')
                  ">
                Please enter a valid expiration date - YYYY
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="col-md-12">
          <mat-form-field class="w-100">
            <input formControlName="cvc"
                   matInput
                   placeholder="CVC *"
                   id="cc-cvc"
                   type="tel"
                   autocomplete="off"
                   ccCVC />
            <mat-error *ngIf="form.controls['cvc'].hasError('required')">
              Please enter a CVC number
            </mat-error>
          </mat-form-field>
        </div>

        <div class="col-md-12" *ngIf="isThirdPartyPayment">
          <mat-checkbox required (change)="termsAcceptAction($event)">
            By checking this box I acknowledge that Wickedlist.com does not give me any assurance that my ROI(return on investment) will be higher than my actual investment!
          </mat-checkbox>
        </div>
      </div>
    </div>
    <div class="row mt-2 m-0" *ngIf="payButtonText != ''">
      <div class="col-12 m-0">
        <button class="w-100 create-button p-1"
                mat-flat-button
                color="primary"
                type="submit">
          <span *ngIf="!creating">
            {{payButtonText}}
          </span>
          <mat-spinner *ngIf="creating" diameter="30"></mat-spinner>

        </button>

      </div>
      <div class="col-12 m-0 text-right">
        * No monthly subscriptions
      </div>
    </div>
  </form>
</div>
